enum QuizIntegrations {
  Rokt = 'rokt',
};

export default QuizIntegrations;
